export const GET_ALL_CHAT_MESSAGES = 'get_all_chat_messages'
export const GET_ALL_NEW_CHAT_MESSAGES = 'get_all_new_chat_messages'
export const SOCKET_CONNECT = 'socket_connection'
